import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import '@/components/journey-visualiser/styles/index.scss'
import 'vue-multiselect/dist/vue-multiselect.css'
import '@/assets/css/multiselect.scss'
import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.mount('#app')
